<template>
  <v-container v-if="$auth.check()">
    <v-row>
      <v-col :cols="12">
        <h1>
          {{ $t('texts.dashboard.label') }}
          <template v-if="!fetchDashboardPending">{{ company.name }}</template>
        </h1>
      </v-col>
    </v-row>
    <missing-information/>
    <v-row>
      <v-col :cols="12">
        <v-card>
          <v-card-title class="primary">
            <span class="white--text headline">
              {{ $t('texts.applications') }}
            </span>
            <v-spacer/>
            <v-btn
              small light color="white" outlined
              :to="`${companyBaseUrl}/applications/ongoing`"
            >
              {{ $t('texts.showAndEdit') }}
            </v-btn>
          </v-card-title>
          <v-card-text>
            {{ $t('texts.dashboard.applicationDescription') }}
          </v-card-text>
          <v-card-text class="pa-0">
            <table-applications
              :loading="fetchDashboardPending"
              :items="applications"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col :cols="12">
        <v-card>
          <v-card-title class="primary">
            <span class="white--text headline">
              {{ $t('texts.jobTitle') }}
            </span>
            <v-spacer/>
            <v-btn
              small light color="white" outlined
              :to="`${companyBaseUrl}/jobs`"
            >
              {{ $t('texts.showAndEdit') }}
            </v-btn>
          </v-card-title>
          <v-card-text>
            {{ $t('texts.dashboard.jobsDescription') }}
          </v-card-text>
          <v-card-text class="pa-0">
            <table-jobs
              :loading="fetchDashboardPending"
              :items="jobs.active"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col :cols="12">
        <v-card>
          <v-card-title class="primary">
            <span class="white--text headline">
              {{ $t('texts.employee.assignment') }}
            </span>
            <v-spacer/>
            <v-btn
              small light color="white" outlined
              :to="`${companyBaseUrl}/employees/assignment`"
            >
              {{ $t('texts.showAndEdit') }}
            </v-btn>
          </v-card-title>
          <v-card-text>
            {{ $t('texts.dashboard.assignmentDescription') }}
            <template v-if="!hasActiveSubscription && !fetchCompanyPending && !fetchDashboardPending">
              <br><span class="error--text">{{ $t('texts.alert.subscriptionRequired.updateEmployee') }}</span>
            </template>
          </v-card-text>
          <v-card-text class="pa-0">
            <table-employee-assignment
              :loading="fetchDashboardPending"
              :items="employeesAssignment"
              :hasActiveSubscription="hasActiveSubscription"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col :cols="12">
        <v-card>
          <v-card-title class="primary">
            <span class="white--text headline">
              {{ $t('texts.employeeReEnter.label') }}
            </span>
            <v-spacer/>
            <v-btn
              small light color="white" outlined
              :to="{ name: 'company.employees.all' }"
            >
              {{ $t('texts.showAndEdit') }}
            </v-btn>
          </v-card-title>
          <v-card-text>
            {{ $t('texts.dashboard.reenterDescription') }}
          </v-card-text>
          <v-card-text class="pa-0">
            <table-employee-re-enter
              :loading="fetchDashboardPending"
              :items="employeesReenter"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col :cols="12">
        <v-card>
          <v-card-title class="primary">
            <span class="white--text headline">
              {{ $tc('texts.cooperationAgreement', 2) }}
            </span>
          </v-card-title>
          <v-card-text class="pa-0">
            <table-cooperation-agreements
              :loading="fetchDashboardPending"
              :items="cooperationAgreements"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import MissingInformation from '@/components/_templates/company/profile/MissingInformation.vue';
import TableApplications from './TableApplications.vue';
import TableJobs from './TableJobs.vue';
import TableEmployeeAssignment from './TableEmployeeAssignment.vue';
import TableEmployeeReEnter from './TableEmployeeReEnter.vue';
import TableCooperationAgreements from './TableCooperationAgreements.vue';

const { mapState: mapCompanyState, mapActions: mapCompanyActions } = createNamespacedHelpers('company');
const { mapState: mapCompanyApplicationsState } = createNamespacedHelpers('company/applications');
const { mapState: mapCompanyJobsState } = createNamespacedHelpers('company/jobs');
const { mapState: mapCompanyEmployeesState } = createNamespacedHelpers('company/employees');
const { mapState: mapCompanyProfileState } = createNamespacedHelpers('company/profile');

export default {
  name: 'CompanyDashboard',
  components: {
    MissingInformation,
    TableApplications,
    TableJobs,
    TableEmployeeAssignment,
    TableEmployeeReEnter,
    TableCooperationAgreements,
  },
  created() {
    this.fetchDashboard(this.selectedCompanyId);
  },
  computed: {
    ...mapCompanyProfileState([
      'company',
      'fetchCompanyPending',
    ]),
    ...mapCompanyState([
      'fetchDashboardPending',
      'cooperationAgreements',
      'fetchCooperationAgreementsPending',
    ]),
    ...mapCompanyApplicationsState([
      'applications',
    ]),
    ...mapCompanyJobsState([
      'jobs',
    ]),
    ...mapCompanyEmployeesState([
      'employeesReenter',
      'employeesAssignment',
    ]),
    companyBaseUrl() {
      return `/company/${this.selectedCompanyId}`;
    },
    hasActiveSubscription() {
      return this.company.active_subscription;
    },
    selectedCompanyId() {
      return this.$route.params.companyId;
    },
  },
  methods: {
    ...mapCompanyActions([
      'fetchDashboard',
    ]),
  },
};
</script>
